import { render, staticRenderFns } from "./FamilyDataInfo.vue?vue&type=template&id=1765e7ef&scoped=true&"
import script from "./FamilyDataInfo.vue?vue&type=script&lang=ts&"
export * from "./FamilyDataInfo.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1765e7ef",
  null
  
)

export default component.exports